import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressSearchInputComponent } from './address-search-input/address-search-input.component';
import { MODULES } from 'src/app/global-modules';
import { DirectivesModule } from '../directives/directives.module';
import { MessageInfoOverlayComponent } from './message-info-overlay/message-info-overlay.component';
import { ImageUploadComponent } from './image-upload/image-upload.component';
import { SelfieCaptureComponent } from './selfie-capture/selfie-capture.component';



@NgModule({
  declarations: [
    AddressSearchInputComponent,
    MessageInfoOverlayComponent,
    ImageUploadComponent,
    SelfieCaptureComponent
  ],
  imports: [
    CommonModule,
    ...MODULES,
    DirectivesModule
  ],
  exports: [
    AddressSearchInputComponent,
    MessageInfoOverlayComponent,
    ImageUploadComponent,
    SelfieCaptureComponent
  ]
})
export class SharedComponentsModule { }
